import { render, staticRenderFns } from "./AddEditProductContent.vue?vue&type=template&id=0ce4b3a8&scoped=true&"
import script from "./AddEditProductContent.vue?vue&type=script&lang=js&"
export * from "./AddEditProductContent.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProductContent.vue?vue&type=style&index=0&id=0ce4b3a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce4b3a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VForm,VIcon,VListItem,VListItemContent,VListItemTitle,VSkeletonLoader})
